export function yubinbango2() {
  const form = document.querySelector('.mw_wp_form');
  if(form) {
    form.classList.add('h-adr');
    new YubinBango.MicroformatDom();
  }
}